module.exports = __webpack_public_path__ + "src/assets/images/icon-pipeline-summary-closed.png?39e89206da7940018e1772ad14263827";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-pipeline-summary-closed.png
// module id = 1005
// module chunks = 1